import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "icons/abb_home_16",
		clipPath: "url(#clip0_1_5788)",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Final icons - Common",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M8 1L2.87 6.13L1 8L2 9V14C2 14.2652 2.10536 14.5196 2.29289 14.7071C2.48043 14.8946 2.73478 15 3 15H13C13.2652 15 13.5196 14.8946 13.7071 14.7071C13.8946 14.5196 14 14.2652 14 14V9L15 8L8 1ZM12 13H9V10H7V13H4V8L8 4L12 8V13Z",
				fill: "#1F1F1F"
			})
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1_5788",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgHome;
